import styled from "@emotion/styled";

export const NewVersionIndicator = styled.span`
  padding: 0.25rem 0.5rem;
  color: var(--mb-color-text-white);
  font-size: 0.75em;
  font-weight: bold;
  background-color: var(--mb-color-brand);
  border-radius: 0.5rem;
`;
